// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseOpCreated
 */
export interface ResponseOpCreated {
  /**
   *
   * @type {number}
   * @memberof ResponseOpCreated
   */
  opId?: number;
}

/**
 * Check if a given object implements the ResponseOpCreated interface.
 */
export function instanceOfResponseOpCreated(
  value: object,
): value is ResponseOpCreated {
  return true;
}

export function ResponseOpCreatedFromJSON(json: any): ResponseOpCreated {
  return ResponseOpCreatedFromJSONTyped(json, false);
}

export function ResponseOpCreatedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseOpCreated {
  if (json == null) {
    return json;
  }
  return {
    opId: json['op_id'] == null ? undefined : json['op_id'],
  };
}

export function ResponseOpCreatedToJSON(json: any): ResponseOpCreated {
  return ResponseOpCreatedToJSONTyped(json, false);
}

export function ResponseOpCreatedToJSONTyped(
  value?: ResponseOpCreated | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    op_id: value['opId'],
  };
}
